"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function YourSanctuaryForRenewal() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="25637" id="a-season-for-growth" className="relative min-h-screen w-full overflow-hidden bg-background flex items-center justify-center py-[15vh]">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline className="h-full w-full object-cover opacity-40" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599111/img/hero_poster.png">
          <source src="/videos/hero_background.mp4" type="video/mp4" />
        </video>
        {}
        <div className="absolute inset-0 bg-secondary/30 backdrop-blur-[1px]" />
        
        {}
        <div className="absolute inset-0 bg-gradient-to-br from-secondary/40 via-transparent to-background/90 pointer-events-none" />
      </div>

      {}
      <div ref={ref} className={cn("relative z-10 container mx-auto px-6 text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <div className="mx-auto max-w-4xl flex flex-col items-center gap-8">
          {}
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-medium text-foreground tracking-tight leading-[1.1]">
            A Season for Growth
          </h1>

          {}
          <div className="h-px w-24 bg-accent/40 my-2" />

          {}
          <p className="font-sans text-lg md:text-xl text-primary/80 max-w-[600px] leading-relaxed">Thoughtful, grounded therapy for individuals across Massachusetts—offering clarity, support, and meaningful change.</p>

          {}
          <div className="pt-4">
            <Button asChild size="lg" className="rounded-full px-10 py-7 text-lg bg-accent text-accent-foreground hover:bg-accent/90 hover:shadow-[0_0_25px_rgba(var(--accent),0.4)] transition-all duration-500 ease-out">
              <Link to="https://forms.gle/QyE7n12agc8JiUNj7">
                Begin Your Healing
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}